<template>
  <div v-if="tabList.length > 0">
    <!-- Header -->
    <div class="mb-6">
      <div
        style="
          font-size: 30px;
          font-weight: 800;
          color: #111827;
          letter-spacing: -0.5px;
          line-height: 1.2;
        "
      >
        Assessment &amp; Form Management
      </div>
      <div class="mt-1" style="font-size: 14px; color: #6b7280">
        Manage skills assessment questions, student profiling forms, and view
        results
      </div>
    </div>

    <v-tabs v-model="activeTab" color="#00A63E" align-tabs="left" class="mb-1">
      <v-tab
        value="Skill Assessment"
        @click="changeTab({ id: 1, name: 'Skill Assessment' })"
      >
        <v-icon size="16" class="mr-1">mdi-file-document-outline</v-icon>
        Skills Assessment
      </v-tab>
      <v-tab
        value="Profiling Form"
        @click="changeTab({ id: 2, name: 'Profiling Form' })"
      >
        <v-icon size="16" class="mr-1">mdi-account-circle-outline</v-icon>
        Profiling Form
      </v-tab>
      <v-tab
        value="Student Result"
        @click="changeTab({ id: 3, name: 'Student Result' })"
      >
        <v-icon size="16" class="mr-1">mdi-clipboard-list-outline</v-icon>
        Student Results
      </v-tab>
    </v-tabs>
    <v-divider class="mb-6" />

    <v-col cols="12" v-if="tab == 1">
      <div
        class="d-flex justify-space-between align-center mb-5"
        v-if="tab == 1 && !expandTab1"
      >
        <div style="font-size: 16px; font-weight: 700; color: #111827">
          Question Banks by Batch
        </div>
        <v-btn
          color="#00A63E"
          variant="flat"
          class="text-white"
          @click="add_batch"
          prepend-icon="mdi-plus"
          rounded="lg"
          size="large"
        >
          New Batch
        </v-btn>
      </div>

      <div>
        <v-row v-if="tab == 1 && !expandTab1">
          <v-col cols="6" v-for="(i, idx) in batchData" :key="i.id">
            <v-card class="batch-card rounded-xl" hover @click="openGroup(i)">
              <v-card-text class="pa-6">
                <div class="batch-icon-box rounded-lg mb-4">
                  <v-icon color="#00a63e" size="20">mdi-folder-open</v-icon>
                </div>
                <div class="batch-title mb-2">{{ i.name }}</div>
                <div class="batch-desc mb-4">{{ batchDescSA(i, idx) }}</div>
                <v-divider class="mb-4" />
                <div class="d-flex align-center batch-meta" style="gap: 16px">
                  <div class="d-flex align-center" style="gap: 4px">
                    <v-icon size="14" color="#6b7280"
                      >mdi-calendar-outline</v-icon
                    >
                    <span>{{ i.year }}</span>
                  </div>
                  <div class="d-flex align-center" style="gap: 4px">
                    <v-icon size="14" color="#6b7280"
                      >mdi-format-list-bulleted</v-icon
                    >
                    <span>{{ i.q_count }} Questions</span>
                  </div>
                  <div class="d-flex align-center" style="gap: 4px">
                    <v-icon size="14" color="#6b7280">mdi-clock</v-icon>
                    <span v-if="i.date_until && i.time_until"
                      >{{
                        formatDate(i.date_until) +
                        " " +
                        formatTime(i.time_until)
                      }}
                    </span>
                    <span v-else>Availability not set</span>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="tab == 1 && expandTab1">
          <v-col cols="12" style="background-color: white; height: 80vh">
            <div>
              <div
                @click="
                  expandTab1 = !expandTab1;
                  initialize();
                "
                color="text-grey "
                class="d-flex justify-start align-center text-subtitle-2 cursor-pointer"
              >
                <div><v-icon>mdi-chevron-left</v-icon></div>
                <div>Back to List</div>
              </div>

              <div
                style="
                  background-color: #f0fdf4;
                  border: 1px solid #d1fae5;
                  border-radius: 12px;
                "
                class="my-4 pa-4 d-flex justify-space-between"
              >
                <div>
                  <div class="text-h5 font-weight-bold">
                    {{ q_bank_data.name }}
                  </div>
                </div>
                <div class="d-flex pa-2 align-center">
                  <div class="mx-4 text-grey text-caption">
                    <v-icon>mdi-calendar</v-icon>&nbsp;&nbsp; Year
                    {{ q_bank_data.year }}
                  </div>
                  <div class="mx-4 text-grey text-caption">
                    <v-icon>mdi-menu</v-icon>&nbsp;&nbsp; Total Questions
                    {{ q_bank_data.q_count }}
                  </div>
                  <div class="mx-4 text-grey text-caption">
                    <v-icon>mdi-clock</v-icon>&nbsp;&nbsp;Availability
                    <span
                      v-if="q_bank_data.date_until && q_bank_data.time_until"
                      >{{
                        formatDate(q_bank_data.date_until) +
                        " " +
                        formatTime(q_bank_data.time_until)
                      }}
                    </span>
                    <span v-else>Availability not set</span>
                  </div>
                </div>
              </div>

              <div class="mt-4">
                <div class="d-flex justify-space-between align-center mb-3">
                  <div
                    class="text-subtitle-1 font-weight-bold"
                    style="color: #111827"
                  >
                    Manage Skill Assessment Questions
                  </div>
                  <div class="d-flex ga-2">
                    <v-btn
                      class="text-white"
                      color="#10b981"
                      @click="setAvailDate"
                      rounded
                      size="small"
                      prepend-icon="mdi-calendar"
                    >
                      Set Availability Date
                    </v-btn>
                    <v-btn
                      class="text-white"
                      color="#10b981"
                      @click="addnew"
                      rounded
                      size="small"
                      prepend-icon="mdi-plus"
                    >
                      Add New
                    </v-btn>
                  </div>
                </div>

                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    gap: 12px;
                    max-height: 420px;
                    overflow-y: auto;
                    padding: 4px 2px;
                  "
                >
                  <div
                    v-for="i in skill_assessment_list"
                    :key="i.id"
                    style="
                      width: 200px;
                      height: 70px;
                      flex-shrink: 0;
                      border: 1px solid #e5e7eb;
                      border-radius: 10px;
                      background: #ffffff;
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                      padding: 0 10px 0 14px;
                      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
                      transition: box-shadow 0.2s;
                    "
                    class="sa-card"
                  >
                    <div
                      style="
                        font-size: 12.5px;
                        font-weight: 600;
                        color: #111827;
                        line-height: 1.4;
                        flex: 1;
                        overflow: hidden;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                      "
                    >
                      {{ i.title }}
                    </div>
                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        gap: 2px;
                        margin-left: 6px;
                        flex-shrink: 0;
                      "
                    >
                      <v-btn
                        @click="editItem(i)"
                        icon
                        color="#6b7280"
                        size="x-small"
                        variant="text"
                      >
                        <v-icon size="15">mdi-pencil</v-icon>
                      </v-btn>
                      <v-btn
                        @click="deleteItem(i)"
                        icon
                        color="#6b7280"
                        size="x-small"
                        variant="text"
                      >
                        <v-icon size="15">mdi-trash-can</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="mt-2">
                <div class="text-h5 font-weight-bold">
                  Manage Skill Assessment Questions
                </div>
                <v-divider></v-divider>
                <div class="mt-4">
                  <div class="d-flex">
                    <v-btn
                      class="text-white mx-2"
                      color="#10b981"
                      @click="addnew"
                      rounded
                      size="small"
                    >
                      Add New
                    </v-btn>
                  </div>
                </div>

                <div class="mt-4">
                  <v-row>
                    <v-col
                      cols="3"
                      v-for="i in skill_assessment_list"
                      :key="i.id"
                    >
                      <div
                        class="pa-2 rounded-lg border border-1 d-flex justify-space-between align-center"
                      >
                        <div>{{ i.title }}</div>
                        <div class="d-flex align-center">
                          <v-btn
                            @click="editItem(i)"
                            icon
                            color="grey"
                            size="small"
                            variant="text"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            @click="deleteItem(i)"
                            icon
                            color="grey"
                            size="small"
                            variant="text"
                          >
                            <v-icon>mdi-trash-can</v-icon>
                          </v-btn>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div> -->
            </div>
          </v-col>
        </v-row>
      </div>
    </v-col>

    <v-col cols="12" v-if="tab == 2">
      <div
        class="d-flex justify-space-between align-center mb-5"
        v-if="tab == 2 && !expandTab2"
      >
        <div style="font-size: 16px; font-weight: 700; color: #111827">
          Profiling Forms by Batch
        </div>
      </div>

      <div>
        <v-row v-if="tab == 2 && !expandTab2">
          <v-col cols="6" v-for="(i, idx) in batchData" :key="i.id">
            <v-card class="batch-card rounded-xl" hover @click="openGroup2(i)">
              <v-card-text class="pa-6">
                <div class="batch-icon-box rounded-lg mb-4">
                  <v-icon color="#00a63e" size="20">mdi-folder-open</v-icon>
                </div>
                <div class="batch-title mb-2">{{ i.name }}</div>
                <div class="batch-desc mb-4">{{ batchDescPF(i, idx) }}</div>
                <v-divider class="mb-4" />
                <div class="d-flex align-center batch-meta" style="gap: 16px">
                  <div class="d-flex align-center" style="gap: 4px">
                    <v-icon size="14" color="#6b7280"
                      >mdi-calendar-outline</v-icon
                    >
                    <span>{{ i.year }}</span>
                  </div>
                  <div class="d-flex align-center" style="gap: 4px">
                    <v-icon size="14" color="#6b7280"
                      >mdi-format-list-bulleted</v-icon
                    >
                    <span>{{ i._count }} Fields</span>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="tab == 2 && expandTab2">
          <v-col cols="12" style="background-color: white; height: 80vh">
            <div>
              <div
                @click="expandTab2 = !expandTab2"
                color="text-grey "
                class="d-flex justify-start align-center text-subtitle-2 cursor-pointer"
              >
                <div><v-icon>mdi-chevron-left</v-icon></div>
                <div>Back to List</div>
              </div>

              <div
                style="
                  background-color: #f0fdf4;
                  border: 1px solid #d1fae5;
                  border-radius: 12px;
                "
                class="my-4 pa-4 d-flex justify-space-between"
              >
                <div>
                  <div class="text-h5 font-weight-bold">
                    {{ batchItem.name }}
                  </div>
                </div>
                <div class="d-flex pa-2 align-center">
                  <div class="mx-4 text-grey text-caption">
                    <v-icon>mdi-calendar</v-icon>&nbsp;&nbsp; Year
                    {{ batchItem.year }}
                  </div>
                  <div class="mx-4 text-grey text-caption">
                    <v-icon>mdi-menu</v-icon>&nbsp;&nbsp; Added Fields
                    {{ batchItem._count }}
                  </div>
                </div>
              </div>

              <div
                class="mt-2 pa-4"
                style="max-height: 580px; overflow: hidden; overflow-y: auto"
              >
                <div class="text-h5 font-weight-bold">
                  Configure Profiling Form
                </div>
                <v-divider></v-divider>
                <div class="mt-4 mb-2">
                  <div class="d-flex justify-space-between align-center">
                    <div class="font-weight-bold text-subtitle-1">
                      Added Form Fields
                    </div>
                    <v-btn
                      class="text-white mx-2"
                      color="#10b981"
                      @click="addfield"
                      rounded
                      size="small"
                    >
                      Add New
                    </v-btn>
                  </div>
                </div>
                <hr />
                <div
                  class="mt-4 px-2 py-6"
                  style="
                    max-height: 500px;
                    overflow-y: auto;
                    overflow-x: hidden;
                  "
                >
                  <v-row>
                    <!-- <v-col cols="3">
                      <div class="rounded-lg border border-1">
                        <div
                          class="px-4 pt-2 pb-1 text-caption font-weight-bold"
                        >
                          First Name
                        </div>
                        <hr />
                        <div
                          class="rounded-lg border border-1 pa-1 ma-3 text-grey text-caption"
                        >
                          First Name
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="3">
                      <div class="rounded-lg border border-1">
                        <div
                          class="px-4 pt-2 pb-1 text-caption font-weight-bold"
                        >
                          Middle Name
                        </div>
                        <hr />
                        <div
                          class="rounded-lg border border-1 pa-1 ma-3 text-grey text-caption"
                        >
                          Middle Name
                        </div>
                      </div>
                    </v-col>

                    <v-col cols="3">
                      <div class="rounded-lg border border-1">
                        <div
                          class="px-4 pt-2 pb-1 text-caption font-weight-bold"
                        >
                          Last Name
                        </div>
                        <hr />
                        <div
                          class="rounded-lg border border-1 pa-1 ma-3 text-grey text-caption"
                        >
                          Last Name
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="3">
                      <div class="rounded-lg border border-1">
                        <div
                          class="px-4 pt-2 pb-1 text-caption font-weight-bold"
                        >
                          Suffix
                        </div>
                        <hr />
                        <div
                          class="rounded-lg border border-1 pa-1 ma-3 text-grey text-caption"
                        >
                          Suffix
                        </div>
                      </div>
                    </v-col>

                    <v-col cols="6">
                      <div class="rounded-lg border border-1">
                        <div
                          class="px-4 pt-2 pb-1 text-caption font-weight-bold"
                        >
                          Program
                        </div>
                        <hr />
                        <div
                          class="rounded-lg border border-1 pa-1 ma-3 text-grey text-caption"
                        >
                          Program
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="6">
                      <div class="rounded-lg border border-1">
                        <div
                          class="px-4 pt-2 pb-1 text-caption font-weight-bold"
                        >
                          Preferred Training Mode
                        </div>
                        <hr />
                        <div
                          class="rounded-lg border border-1 pa-1 ma-3 text-grey text-caption"
                        >
                          Preferred Training Mode
                        </div>
                      </div>
                    </v-col> -->
                    <v-col cols="12" v-for="i in added_fields" :key="i.id">
                      <div class="rounded-lg border border-1 py-2">
                        <div class="d-flex justify-space-between align-center">
                          <div
                            class="px-4 pt-2 pb-1 text-caption font-weight-bold"
                          >
                            {{ i.field_name }}
                          </div>
                          <div class="d-flex align-center">
                            <v-btn
                              icon
                              color="grey"
                              size="small"
                              variant="text"
                              @click="editField(i)"
                            >
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn
                              icon
                              color="grey"
                              size="small"
                              variant="text"
                              @click="removeField(i)"
                            >
                              <v-icon>mdi-trash-can</v-icon>
                            </v-btn>
                          </div>
                        </div>
                        <hr />
                        <div
                          v-if="
                            i.field_type == 'Textfield' ||
                            i.field_type == 'Textarea'
                          "
                          class="text-caption pa-2"
                        >
                          <v-text-field
                            v-if="i.field_type == 'Textfield'"
                            hide-details
                            :label="i.field_name"
                            readonly
                            :color="$vuetify.theme.themes.light.inputColor"
                            variant="outlined"
                            density="compact"
                          ></v-text-field>
                          <v-textarea
                            v-if="i.field_type == 'Textarea'"
                            hide-details
                            :label="i.field_name"
                            readonly
                            rows="3"
                            :color="$vuetify.theme.themes.light.inputColor"
                            variant="outlined"
                            density="compact"
                          ></v-textarea>
                        </div>

                        <div
                          v-if="i.field_type == 'Radio Button'"
                          class="text-caption"
                        >
                          <v-radio-group inline>
                            <v-radio
                              v-for="(j, index) in i.field_options"
                              :key="index"
                              :label="j.option_name"
                            ></v-radio>
                          </v-radio-group>
                        </div>
                        <div
                          v-if="i.field_type == 'Dropdown'"
                          class="text-caption pa-1"
                        >
                          <v-autocomplete
                            dense
                            hide-details
                            :label="i.field_name"
                            class="rounded-lg"
                            item-value="option_name"
                            item-title="option_name"
                            :color="$vuetify.theme.themes.light.inputColor"
                            variant="outlined"
                            density="compact"
                            :items="i.field_options"
                          >
                          </v-autocomplete>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-col>

    <v-col cols="12" v-if="tab == 3">
      <div
        class="d-flex justify-space-between align-center mb-5"
        v-if="tab == 3 && !expandTab3"
      >
        <div style="font-size: 16px; font-weight: 700; color: #111827">
          Students by Batch
        </div>
      </div>

      <div>
        <v-row v-if="tab == 3 && !expandTab3">
          <v-col cols="6" v-for="(i, idx) in batchData" :key="i.id">
            <v-card class="batch-card rounded-xl" hover @click="openGroup3(i)">
              <v-card-text class="pa-6">
                <div class="batch-icon-box rounded-lg mb-4">
                  <v-icon color="#00a63e" size="20">mdi-folder-open</v-icon>
                </div>
                <div class="batch-title mb-2">{{ i.name }}</div>
                <div class="batch-desc mb-4">{{ batchDescSR(i, idx) }}</div>
                <v-divider class="mb-4" />
                <div class="d-flex align-center batch-meta" style="gap: 16px">
                  <div class="d-flex align-center" style="gap: 4px">
                    <v-icon size="14" color="#6b7280"
                      >mdi-calendar-outline</v-icon
                    >
                    <span>{{ i.year }}</span>
                  </div>
                  <div class="d-flex align-center" style="gap: 4px">
                    <v-icon size="14" color="#6b7280"
                      >mdi-account-multiple-outline</v-icon
                    >
                    <span>{{ i._count }} Students</span>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="tab == 3 && expandTab3">
          <v-col cols="12" style="background-color: white; height: 80vh">
            <div>
              <div
                @click="expandTab3 = !expandTab3"
                color="text-grey "
                class="d-flex justify-start align-center text-subtitle-2 cursor-pointer"
              >
                <div><v-icon>mdi-chevron-left</v-icon></div>
                <div>Back to List</div>
              </div>

              <div
                style="
                  background-color: #f0fdf4;
                  border: 1px solid #d1fae5;
                  border-radius: 12px;
                  gap: 16px;
                "
                class="my-4 pa-4 d-flex justify-space-between align-center flex-wrap"
              >
                <div>
                  <div class="text-h5 font-weight-bold">
                    {{ batchItem.name }}
                  </div>
                  <div
                    class="d-flex align-center mt-1 text-grey text-caption"
                    style="gap: 16px"
                  >
                    <span class="d-flex align-center" style="gap: 4px">
                      <v-icon size="14">mdi-calendar</v-icon>
                      Year {{ batchItem.year }}
                    </span>
                    <span class="d-flex align-center" style="gap: 4px">
                      <v-icon size="14">mdi-account-multiple-outline</v-icon>
                      Students
                      <template v-if="programFilter"
                        >{{ totalStudents }} of </template
                      >{{ batchItem._count }}
                    </span>
                    <span
                      v-if="allStudentsLoading && exportProgress.total"
                      class="d-flex align-center"
                      style="gap: 4px; color: #00a63e"
                    >
                      <v-icon size="14">mdi-timer-sand</v-icon>
                      Loading students {{ exportProgress.loaded }} /
                      {{ exportProgress.total }}
                    </span>
                  </div>
                </div>

                <div class="d-flex align-center flex-wrap" style="gap: 12px">
                  <div style="width: 240px">
                    <v-text-field
                      v-model="search"
                      label="Search"
                      prepend-inner-icon="mdi-magnify"
                      variant="outlined"
                      density="compact"
                      hide-details
                      color="primary"
                      bg-color="white"
                      class="rounded-lg"
                    />
                  </div>
                  <div style="width: 300px">
                    <v-select
                      v-model="programFilter"
                      :items="programSelectItems"
                      item-title="title"
                      item-value="value"
                      label="Program"
                      prepend-inner-icon="mdi-school-outline"
                      clearable
                      variant="outlined"
                      density="compact"
                      hide-details
                      color="primary"
                      bg-color="white"
                      class="rounded-lg"
                    >
                      <template #no-data>
                        <v-list-item title="No programs found" />
                      </template>
                    </v-select>
                  </div>
                  <v-btn
                    color="#00A63E"
                    variant="flat"
                    height="40"
                    class="text-white text-none"
                    rounded="lg"
                    prepend-icon="mdi-microsoft-excel"
                    @click="openExportDialog"
                  >
                    Export Excel
                  </v-btn>
                </div>
              </div>

              <v-card
                flat
                class="rounded-xl"
                style="
                  overflow-y: auto;
                  max-height: 500px;
                  border: 1px solid #d1d5db;
                  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
                "
              >
                <!-- <v-data-table
                  :headers="headers"
                  :items="studentList"
                  :search="search"
                  :loading="loading"
                  hover
                  density="compact"
                  class="rounded-lg"
                  show-expand
                > -->
                <v-data-table-server
                  :headers="headers"
                  :items="studentList"
                  :items-length="totalStudents"
                  :loading="loading"
                  v-model:page="serverOptions.page"
                  v-model:items-per-page="serverOptions.itemsPerPage"
                  @update:options="loadStudents"
                  hover
                  density="compact"
                  class="rounded-lg"
                  show-expand
                >
                  <template
                    v-slot:[`item.data-table-expand`]="{
                      internalItem,
                      isExpanded,
                      toggleExpand,
                    }"
                  >
                    <v-btn
                      :append-icon="
                        isExpanded(internalItem)
                          ? 'mdi-chevron-up'
                          : 'mdi-chevron-down'
                      "
                      :text="isExpanded(internalItem) ? 'Collapse' : 'Details'"
                      class="text-none"
                      color="medium-emphasis"
                      size="small"
                      variant="text"
                      width="105"
                      border
                      slim
                      @click="toggleExpand(internalItem)"
                    ></v-btn>
                  </template>

                  <template v-slot:expanded-row="{ columns, item }">
                    <tr>
                      <td :colspan="columns.length" class="py-2">
                        <div class="pa-2 rounded-lg border border-1">
                          <v-row>
                            <v-col
                              cols="3"
                              v-for="(i, idx) in item.skill_assessment.data"
                              :key="idx"
                            >
                              <div
                                class="pa-2 border border-1 rounded-lg text-caption"
                                :class="
                                  i.isAnswered
                                    ? 'bg-green text-white'
                                    : 'text-grey'
                                "
                              >
                                <div>Title: {{ i.title }}</div>
                                <div v-if="i.score">
                                  Score: {{ i.score + "/" + i.num_items }}
                                </div>
                              </div>
                            </v-col>
                          </v-row>
                        </div>
                      </td>
                    </tr>
                  </template>
                  <template v-slot:[`item.program_tied`]="{ item }">
                    <div v-for="(it, i) in item.programName" :key="i">
                      {{ it.name }}
                    </div>
                  </template>
                  <template v-slot:[`item.assessment_taken`]="{ item }">
                    <div class="text-caption" style="color: #00a63e">
                      {{
                        item.skill_assessment.total_answered +
                        "/" +
                        item.skill_assessment.data.length
                      }}
                    </div>
                  </template>

                  <!-- <template v-slot:[`item.actions`]="{ item }">
                    <v-btn
                      color="#00a63e"
                      variant="text"
                      size="small"
                      @click="viewStudentItem(item)"
                    >
                      Details
                    </v-btn>
                  </template> -->

                  <template #no-data>
                    <i>No data found.</i>
                  </template>
                  <!-- </v-data-table> -->
                </v-data-table-server>
              </v-card>

              <!-- <div class="mt-2">
                <div class="text-h5 font-weight-bold">
                  Configure Profiling Form
                </div>
                <v-divider></v-divider>
                <div class="mt-4">
                  <div class="d-flex justify-space-between align-center">
                    <div class="font-weight-bold text-subtitle-1">
                      Form Fields
                    </div>
                    <v-btn
                      class="text-white mx-2"
                      color="#10b981"
                      @click="addfield"
                      rounded
                      size="small"
                    >
                      Add New
                    </v-btn>
                  </div>
                </div>

                <div class="mt-4">
                  <v-row>
                    <v-col cols="3">
                      <div class="rounded-lg border border-1">
                        <div
                          class="px-4 pt-2 pb-1 text-caption font-weight-bold"
                        >
                          First Name
                        </div>
                        <hr />
                        <div
                          class="rounded-lg border border-1 pa-1 ma-3 text-grey text-caption"
                        >
                          First Name
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="3">
                      <div class="rounded-lg border border-1">
                        <div
                          class="px-4 pt-2 pb-1 text-caption font-weight-bold"
                        >
                          Middle Name
                        </div>
                        <hr />
                        <div
                          class="rounded-lg border border-1 pa-1 ma-3 text-grey text-caption"
                        >
                          Middle Name
                        </div>
                      </div>
                    </v-col>

                    <v-col cols="3">
                      <div class="rounded-lg border border-1">
                        <div
                          class="px-4 pt-2 pb-1 text-caption font-weight-bold"
                        >
                          Last Name
                        </div>
                        <hr />
                        <div
                          class="rounded-lg border border-1 pa-1 ma-3 text-grey text-caption"
                        >
                          Last Name
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="3">
                      <div class="rounded-lg border border-1">
                        <div
                          class="px-4 pt-2 pb-1 text-caption font-weight-bold"
                        >
                          Suffix
                        </div>
                        <hr />
                        <div
                          class="rounded-lg border border-1 pa-1 ma-3 text-grey text-caption"
                        >
                          Suffix
                        </div>
                      </div>
                    </v-col>

                    <v-col cols="6">
                      <div class="rounded-lg border border-1">
                        <div
                          class="px-4 pt-2 pb-1 text-caption font-weight-bold"
                        >
                          Program
                        </div>
                        <hr />
                        <div
                          class="rounded-lg border border-1 pa-1 ma-3 text-grey text-caption"
                        >
                          Program
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="6">
                      <div class="rounded-lg border border-1">
                        <div
                          class="px-4 pt-2 pb-1 text-caption font-weight-bold"
                        >
                          Preferred Training Mode
                        </div>
                        <hr />
                        <div
                          class="rounded-lg border border-1 pa-1 ma-3 text-grey text-caption"
                        >
                          Preferred Training Mode
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="6" v-for="i in added_fields" :key="i.id">
                      <div class="rounded-lg border border-1">
                        <div class="d-flex justify-space-between align-center">
                          <div
                            class="px-4 pt-2 pb-1 text-caption font-weight-bold"
                          >
                            {{ i.field_name }}
                          </div>
                          <div class="d-flex align-center">
                            <v-btn
                              icon
                              color="grey"
                              size="small"
                              variant="text"
                              @click="editField(i)"
                            >
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn
                              icon
                              color="grey"
                              size="small"
                              variant="text"
                              @click="removeField(i)"
                            >
                              <v-icon>mdi-trash-can</v-icon>
                            </v-btn>
                          </div>
                        </div>
                        <hr />
                        <div
                          class="rounded-lg border border-1 pa-1 ma-3 text-grey text-caption"
                        >
                          {{ i.field_name }}
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div> -->
            </div>
          </v-col>
        </v-row>
      </div>
    </v-col>

    <!-- Data Table -->
    <!-- <v-card elevation="2" class="pa-2" >
      <v-data-table
        :headers="headers"
        :items="data"
        :search="search"
        :loading="loading"
        hover
        density="compact"
        class="rounded-lg"
      >
        <template v-slot:[`item.program_tied`]="{ item }">
          <div v-for="(it, i) in item.programName" :key="i">{{ it.name }}</div>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          
          <v-tooltip text="Edit" location="top">
            <template #activator="{ props }">
              <v-btn
                icon
                color="warning"
                variant="text"
                v-bind="props"
                @click="editItem(item)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
          </v-tooltip>

        </template>

        <template #no-data>
          <i>No data found.</i>
        </template>
      </v-data-table>
    </v-card> -->

    <!-- Dialogs -->
    <SkillAssessmentDialog
      :data="itemData"
      :action="action"
      :programs="programs_for"
    />

    <SkillAssessmentBatchDialog
      :data="group_data"
      :action="action"
      :batchToAdd="tab"
    />

    <SetDateTimeAvailabilityDialog :data="availData" :action="'Update'" />

    <AddProfilingFieldDialog :data="fieldData" :action="action" />

    <v-dialog v-model="dialogConfirmDelete" max-width="500">
      <v-card>
        <v-card-title class="text-h6">Confirm Deletion</v-card-title>
        <v-card-text class="text-body-1">
          Are you sure you want to delete this item?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="dialogConfirmDelete = false"
            >Cancel</v-btn
          >
          <v-btn color="error" class="white--text" @click="confirmDelete"
            >Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Export Student Results Dialog -->
    <v-dialog v-model="exportDialog" max-width="540" persistent>
      <v-card class="rounded-xl">
        <v-card-title class="text-h6 font-weight-bold pt-5 px-6">
          Export Student Results
        </v-card-title>
        <v-card-subtitle class="px-6" style="white-space: normal">
          Download the skills assessment scores of
          <b>{{ batchItem ? batchItem.name : "" }}</b> as an Excel file.
        </v-card-subtitle>
        <v-card-text class="px-6 pt-4">
          <div v-if="exportLoading" class="py-4">
            <div class="d-flex justify-space-between align-center mb-2">
              <span class="text-body-2 text-grey-darken-1">
                Loading students...
              </span>
              <span
                v-if="exportProgress.total"
                class="text-caption font-weight-bold"
                style="color: #00a63e"
              >
                {{ exportProgress.loaded }} / {{ exportProgress.total }} ({{
                  exportProgressPercent
                }}%)
              </span>
            </div>
            <v-progress-linear
              :indeterminate="!exportProgress.total"
              :model-value="exportProgressPercent"
              color="#00A63E"
              height="8"
              rounded
            />
            <div
              v-if="exportProgress.total"
              class="text-caption text-grey mt-2"
            >
              Fetching page {{ exportProgress.page }} of
              {{ exportProgress.pages }}
            </div>
          </div>
          <div v-else-if="programFilter">
            <div class="text-subtitle-2 font-weight-bold mb-2">Program</div>
            <v-chip
              color="#00A63E"
              variant="tonal"
              label
              style="height: auto; white-space: normal"
              class="py-2"
            >
              <v-icon start size="16">mdi-school-outline</v-icon>
              {{ programFilterLabel }}
            </v-chip>
            <div class="text-caption text-grey-darken-1 mt-3">
              <v-icon size="14" class="mr-1"
                >mdi-account-multiple-outline</v-icon
              >
              {{ exportCount }} student(s) will be exported. Clear the program
              filter on the page to export other programs.
            </div>
          </div>
          <div v-else>
            <div class="d-flex justify-space-between align-center mb-2">
              <div class="text-subtitle-2 font-weight-bold">Program</div>
              <div>
                <v-btn
                  size="x-small"
                  variant="text"
                  color="#00A63E"
                  class="text-none"
                  @click="selectAllExportPrograms"
                >
                  Select all
                </v-btn>
                <v-btn
                  size="x-small"
                  variant="text"
                  color="grey"
                  class="text-none"
                  @click="exportSelectedPrograms = []"
                >
                  Clear
                </v-btn>
              </div>
            </div>
            <v-select
              v-model="exportSelectedPrograms"
              :items="exportProgramOptions"
              item-title="title"
              item-value="value"
              label="Select program(s) to export"
              multiple
              chips
              closable-chips
              variant="outlined"
              density="compact"
              hide-details
              color="#00A63E"
              class="rounded-lg"
            />
            <div class="text-caption text-grey-darken-1 mt-3">
              <v-icon size="14" class="mr-1"
                >mdi-account-multiple-outline</v-icon
              >
              {{ exportCount }} of {{ exportStudents.length }} students will be
              exported
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="px-6 pb-5">
          <v-spacer />
          <v-btn
            variant="text"
            class="text-none"
            :disabled="exporting"
            @click="closeExportDialog"
          >
            Cancel
          </v-btn>
          <v-btn
            color="#00A63E"
            variant="flat"
            class="text-white text-none"
            prepend-icon="mdi-download"
            :loading="exporting"
            :disabled="exportLoading || exportCount === 0"
            @click="exportToExcel"
          >
            Export
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    />
  </div>
</template>

<script>
import eventBus from "@/eventBus";
import SkillAssessmentDialog from "../Dialogs/Forms/SkillAssessment/SkillAssessmentDialog.vue";
import SkillAssessmentBatchDialog from "../Dialogs/Forms/SkillAssessment/SkillAssessmentBatchDialog.vue";
import AddProfilingFieldDialog from "../Dialogs/Forms/AddProfilingFieldDialog.vue";
import SetDateTimeAvailabilityDialog from "../Dialogs/Forms/SetDateTimeAvailabilityDialog.vue";

export default {
  components: {
    SkillAssessmentDialog,
    SkillAssessmentBatchDialog,
    AddProfilingFieldDialog,
    SetDateTimeAvailabilityDialog,
  },

  // props: {
  //   reloadTable: {
  //     type: Boolean,
  //     required: true,
  //   },
  // },
  data: () => ({
    search: "",
    headers: [
      { title: "Student", value: "name", align: "start" },
      { title: "Program", value: "pg_name", align: "start" },
      {
        title: "Assessments Taken",
        value: "assessment_taken",
        align: "center",
      },

      // {
      //   title: "Actions",
      //   value: "actions",
      //   align: "center",
      //   sortable: false,
      //   width: 200,
      // },
    ],
    data: [],
    activeTab: "Skill Assessment",
    tab: 1,
    tabList: [
      { id: 1, name: "Skill Assessment" },
      { id: 2, name: "Profiling Form" },
      { id: 3, name: "Student Result" },
    ],
    programs_for: [],
    perPageChoices: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "20", value: 20 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "250", value: 250 },
      { text: "500", value: 500 },
    ],
    expandTab1: false,
    expandTab2: false,
    expandTab3: false,
    q_bank_data: null,
    skill_assessment_list: [],
    added_fields: [],
    batchItem: null,
    totalCount: 0,
    group_data: null,
    deleteData: null,
    batchData: null,
    fieldData: null,
    studentList: [],
    itemData: null,
    viewData: null,
    loading: false,
    options: {},
    action: null,
    paginationData: {},
    formdata: [],
    creds: null,
    dialogConfirmDelete: false,
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Deleted!",
      message: "",
      top: 10,
    },
    totalStudents: 0,
    serverOptions: {
      page: 1,
      itemsPerPage: 10,
    },
    searchTimeout: null,
    programFilter: null, // selected program name (null = all programs)
    allStudents: null, // every student of the open batch (cached, frozen)
    fullLoadedAt: 0, // when the whole batch was last loaded
    programLoadedAt: {}, // program id -> when only that program was reloaded
    allStudentsLoading: false,
    allStudentsPromise: null,
    availabilityDialog: false,
    availData: null,
    // Excel export
    exportDialog: false,
    exportLoading: false,
    exporting: false,
    exportStudents: [],
    exportSelectedPrograms: [],
    exportProgress: { loaded: 0, total: 0, page: 0, pages: 0 },
    exportRunId: 0, // lets a closed dialog cancel an in-flight load
  }),
  computed: {
    // Options come from the programs list loaded when the page mounts,
    // so the dropdown is available immediately (no student fetch needed).
    programSelectItems() {
      return (this.programs_for || []).map((p) => {
        const id = Number(p.program_id ?? p.id);
        return {
          title:
            p.name || p.program_name || p.title || p.abbr || `Program ${id}`,
          value: id,
        };
      });
    },
    programFilterLabel() {
      const item = this.programSelectItems.find(
        (i) => i.value === this.programFilter,
      );
      return item ? item.title : "";
    },
    exportProgressPercent() {
      const { loaded, total } = this.exportProgress;
      return total ? Math.min(100, Math.round((loaded / total) * 100)) : 0;
    },
    // Unique programs found in the batch, with student counts
    exportProgramOptions() {
      const counts = {};
      this.exportStudents.forEach((s) => {
        const p = this.getExportProgramName(s);
        counts[p] = (counts[p] || 0) + 1;
      });
      return Object.keys(counts)
        .sort((a, b) => a.localeCompare(b))
        .map((p) => ({ title: `${p} (${counts[p]})`, value: p }));
    },
    exportFilteredStudents() {
      const selected = new Set(this.exportSelectedPrograms);
      return this.exportStudents.filter((s) =>
        selected.has(this.getExportProgramName(s)),
      );
    },
    exportCount() {
      return this.exportFilteredStudents.length;
    },
  },
  mounted() {
    this.getProgramsHandled();
    // this.initialize();

    eventBus.on("closeSkillAssessmentDialog", () => {
      this.loadSAS();
    });
    eventBus.on("closeSkillAssessmentBatchDialog", () => {
      this.initialize();
    });
    eventBus.on("closeAddProfilingFieldDialog", () => {
      this.loadAddedFields();
    });

    eventBus.on("closeSetDateTimeDialog", () => {
      this.loadBatchById();
    });
  },
  watch: {
    async programFilter(val) {
      this.serverOptions.page = 1; // back to page 1 when the program changes
      if (!val) {
        this.loadStudents(); // cleared -> normal server-side paging
        return;
      }

      this.loading = true;
      try {
        // loads / refreshes only the chosen program's students
        await this.ensureAllStudents(val);
      } catch (e) {
        console.error("Program filter load failed", e);
        this.showMessage("error", "Failed to load students for the filter.");
        this.loading = false;
        this.programFilter = null;
        return;
      }
      this.loadStudents();
    },
    search() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.serverOptions.page = 1; // reset to page 1 on new search term
        this.loadStudents();
      }, 400);
    },
  },
  beforeUnmount() {
    eventBus.off("closeSkillAssessmentDialog");
    eventBus.off("closeSkillAssessmentBatchDialog");
    eventBus.off("closeAddProfilingFieldDialog");
    eventBus.off("closeSetDateTimeDialog");
  },
  methods: {
    pagination(data) {
      this.paginationData = data;
    },
    initialize() {
      // this.loading = true;

      if (this.tab == 1) {
        this.axiosCall("/skill-assessement/get-batch/", "GET").then((res) => {
          if (res) {
            console.log("Bacthers", res.data);
            this.batchData = res.data;
            this.loading = false;
          }
        });
      } else if (this.tab == 2) {
        this.axiosCall("/student/get-batches", "GET").then((res) => {
          if (res) {
            console.log(res.data);
            this.batchData = res.data;
            this.loading = false;
          }
        });
      } else if (this.tab == 3) {
        this.loading = true;
        console.log("called me here");
        this.axiosCall("/student/get-batches-for-students", "GET").then(
          (res) => {
            if (res) {
              console.log(res.data);
              this.batchData = res.data;
              this.loading = false;
            }
          },
        );
      }
    },

    changeTab(tab) {
      // this.activeTab = tab.abbr;
      // this.tab = tab.program_id;
      this.activeTab = tab.name;
      this.tab = tab.id;

      this.expandTab1 = false;

      this.expandTab2 = false;

      this.expandTab3 = false;

      this.initialize();
    },

    openGroup(item) {
      this.skill_assessment_list = [];
      this.expandTab1 = true;
      this.q_bank_data = item;
      this.loadSAS();
    },

    openGroup2(item) {
      this.expandTab2 = true;
      this.batchItem = item;
      this.loadAddedFields();
    },

    openGroup3(item) {
      this.expandTab3 = true;
      this.batchItem = item;
      this.serverOptions.page = 1;
      this.allStudents = null; // new batch -> drop the cached list
      this.fullLoadedAt = 0;
      this.programLoadedAt = {};
      this.programFilter = null;
      this.loadStudents();
    },

    loadSAS() {
      this.axiosCall(
        "/skill-assessement/getSAByGroupId/" + this.q_bank_data.id,
        "GET",
      ).then((res) => {
        if (res) {
          this.skill_assessment_list = res.data;
        }
      });
    },

    loadAddedFields() {
      this.axiosCall(
        "/student/getAddedFieldsByBatch/" + this.batchItem.id,
        "GET",
      ).then((res) => {
        if (res) {
          console.log("FIELDs", res.data);
          this.added_fields = res.data;
        }
      });
    },

    loadStudents() {
      // A program is selected -> filter and paginate the cached list locally
      if (this.programFilter && this.allStudents) {
        this.applyProgramFilter();
        return;
      }

      this.loading = true;
      const { page, itemsPerPage } = this.serverOptions;

      this.axiosCall(
        `/student/getAllStudentsByBatch/${
          this.batchItem.id
        }?page=${page}&limit=${itemsPerPage}&search=${encodeURIComponent(
          this.search,
        )}`,
        "GET",
      ).then((res) => {
        if (this.programFilter) return; // a program was picked meanwhile
        if (res) {
          let data = res.data.data;
          data.forEach((element, i) => {
            data[i].name = this.toTitleCase(element.name);
          });
          this.studentList = data;

          console.log("CALLED LOAD STUDENT");

          this.totalStudents = res.data.totalCount;
          this.loading = false;
        }
      });
    },

    // Local equivalent of the server query: program + search + paging
    applyProgramFilter() {
      const { page, itemsPerPage } = this.serverOptions;
      const term = (this.search || "").trim().toLowerCase();

      let list = this.allStudents.filter(
        (s) => Number(s.program_id) === this.programFilter,
      );
      if (term) {
        list = list.filter((s) => (s.name || "").toLowerCase().includes(term));
      }

      this.totalStudents = list.length;
      const pageRows =
        itemsPerPage === -1
          ? list
          : list.slice((page - 1) * itemsPerPage, page * itemsPerPage);
      this.studentList = pageRows.map((s) => ({
        ...s,
        name: this.toTitleCase(s.name || ""),
      }));
      this.loading = false;
    },

    loadBatchById() {
      this.axiosCall(
        "/skill-assessement/get-batch-by-id/" + this.q_bank_data.id,
        "GET",
      ).then((res) => {
        if (res) {
          this.q_bank_data = res.data;
        }
      });
    },

    // loadStudents() {
    //   console.log("FETCBIBG ...");
    //   this.loading = true;
    //   this.axiosCall(
    //     "/student/getAllStudentsByBatch/" + this.batchItem.id,
    //     "GET",
    //   ).then((res) => {
    //     if (res) {
    //       console.log("STUDNETDS", res.data);
    //       this.studentList = res.data;
    //       this.loading = false;
    //     }
    //   });
    // },

    getProgramsHandled() {
      this.axiosCall("/program/getProgramsHandled", "GET").then((res) => {
        if (res) {
          console.log("Prog", res.data);
          this.programs_for = res.data;
          // this.activeTab = res.data[0].abbr;
          // this.tabList = res.data;
          // this.tab = res.data[0].program_id;
          console.log(this.tabList);
          this.initialize();
        }
      });
    },
    addnew() {
      this.itemData = {
        id: null,
        skill_assessment_group_id: this.q_bank_data.id,
      };
      this.action = "Add";
    },

    setAvailDate() {
      this.availData = {
        id: this.q_bank_data.id,
        date_until: this.q_bank_data.date_until,
        time_until: this.q_bank_data.time_until,
      };
    },

    addfield() {
      console.log("Bathid", this.batchItem);
      this.fieldData = {
        id: null,
        student_batch_id: this.batchItem.id,
      };
      this.action = "Add";
    },

    editField(item) {
      console.log("Bathid", this.batchItem);
      this.fieldData = item;
      this.action = "Update";
    },

    removeField(item) {
      let confirm = window.confirm(
        "Are you sure you want to delete this field?",
      );
      if (confirm) {
        this.axiosCall(
          "/student/remove_added_field/" + item.id,
          "DELETE",
          {},
        ).then((res) => {
          if (res.data.status == 200) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
            this.loadAddedFields();
          } else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
          }
        });
      }
    },

    batchDescSA(item, idx) {
      return idx === 0
        ? `Standard assessment and profiling for the ${item.year} internship program.`
        : `Archived assessment questions and forms from previous year.`;
    },
    batchDescPF(item, idx) {
      return idx === 0
        ? `Active profiling form configuration for the ${item.year} batch.`
        : `Archived profiling form fields from the ${item.year} batch.`;
    },
    batchDescSR(item, idx) {
      return idx === 0
        ? `View student assessment results for the ${item.year} internship batch.`
        : `Historical student results from the ${item.year} internship batch.`;
    },
    add_batch() {
      this.group_data = { id: null };
      this.action = "Add";
    },
    deleteItem(item) {
      let confirm = window.confirm(
        "Are you sure you want to delete this item and its contents?",
      );
      if (confirm) {
        this.axiosCall("/skill-assessement/removeSA", "POST", {
          skill_assessment_ids: JSON.stringify(item.skill_assessment_ids),
        }).then((res) => {
          if (res.data.status == 200) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
            this.loadSAS();
          } else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
          }
        });
      }
    },
    editItem(item) {
      this.itemData = item;
      this.action = "Update";
    },

    viewItem(item) {
      this.itemData = item;
      this.action = "View";
    },

    manageItem(item) {
      this.creds = item;
    },
    confirmDelete() {
      this.axiosCall("/request-type/" + this.deleteData.id, "DELETE").then(
        () => {
          this.fadeAwayMessage.show = true;
          this.itemData = null;
          this.initialize();
        },
      );
    },

    // ---------- Excel export (Student Results) ----------
    getExportProgramName(student) {
      return (
        student.pg_name ||
        (student.programName &&
          student.programName[0] &&
          student.programName[0].name) ||
        "No Program"
      );
    },

    // Program name (as shown in the table) of a program id, from the cache
    getProgramNameById(id) {
      if (!id || !this.allStudents) return null;
      const st = this.allStudents.find((x) => Number(x.program_id) === id);
      return st ? this.getExportProgramName(st) : null;
    },

    // Preselect the program chosen in the banner filter, otherwise all
    preselectExportPrograms() {
      if (this.programFilter) {
        // locked to the page's program (empty when it has no students)
        const name = this.getProgramNameById(this.programFilter);
        this.exportSelectedPrograms = name ? [name] : [];
      } else {
        this.selectAllExportPrograms();
      }
    },

    selectAllExportPrograms() {
      this.exportSelectedPrograms = this.exportProgramOptions.map(
        (o) => o.value,
      );
    },

    showMessage(type, message) {
      this.fadeAwayMessage.show = true;
      this.fadeAwayMessage.type = type;
      this.fadeAwayMessage.message = message;
      this.fadeAwayMessage.header = "System Message";
    },

    closeExportDialog() {
      this.exportRunId++; // aborts a load that is still running
      this.exportDialog = false;
    },

    // Fetches the students of a batch, page by page, reporting progress.
    // With a programId the request asks for that program only.
    async fetchAllStudents(batchId, programId = null) {
      const limit = 10;
      const programParam = programId ? `&programId=${programId}` : "";
      let page = 1;
      let all = [];
      let total = 0;

      do {
        const res = await this.axiosCall(
          `/student/getAllStudentsByBatch/${batchId}?page=${page}&limit=${limit}&search=${programParam}`,
          "GET",
        );
        if (!res || !res.data) break;

        const rows = res.data.data || [];
        total = res.data.totalCount || 0;
        all = all.concat(rows);

        this.exportProgress = {
          loaded: Math.min(all.length, total),
          total,
          page,
          pages: Math.max(1, Math.ceil(total / limit)),
        };

        if (rows.length === 0) break;
        page++;
      } while (all.length < total);

      if (all.length < total) throw new Error("Could not load all students");
      console.log("FETCHD", all);
      all.sort((a, b) => a.lname.localeCompare(b.lname));

      return all;
    },

    // Returns the cached student list. Data is reused for 3 minutes; when it
    // is older, it is reloaded - only the given program when programId is
    // passed (merged into the cache), otherwise the whole batch.
    // Concurrent callers share one request.
    async ensureAllStudents(programId = null) {
      const TTL = 180000;
      const now = Date.now();
      const fullFresh = this.allStudents && now - this.fullLoadedAt < TTL;
      const programFresh =
        programId &&
        this.allStudents &&
        now - (this.programLoadedAt[programId] || 0) < TTL;
      if (fullFresh || programFresh) return this.allStudents;
      if (this.allStudentsPromise) return this.allStudentsPromise;

      const batchId = this.batchItem.id;
      this.allStudentsLoading = true;
      this.exportProgress = { loaded: 0, total: 0, page: 0, pages: 0 };

      this.allStudentsPromise = this.fetchAllStudents(batchId, programId)
        .then((rows) => {
          if (!this.batchItem || this.batchItem.id !== batchId) return rows;

          const stamp = Date.now();
          let next;
          const onlyThatProgram =
            programId && rows.every((r) => Number(r.program_id) === programId);

          if (onlyThatProgram) {
            // Server returned just that program -> merge into the cache
            next = (this.allStudents || [])
              .filter((x) => Number(x.program_id) !== programId)
              .concat(rows)
              .sort((x, y) => x.id - y.id);
            this.programLoadedAt = {
              ...this.programLoadedAt,
              [programId]: stamp,
            };
          } else {
            // Whole batch (also the case when the server ignores programId)
            next = rows;
            this.fullLoadedAt = stamp;
            this.programLoadedAt = {};
          }

          this.allStudents = Object.freeze(next); // no deep reactivity needed
          return this.allStudents;
        })
        .finally(() => {
          this.allStudentsLoading = false;
          this.allStudentsPromise = null;
        });

      return this.allStudentsPromise;
    },

    async openExportDialog() {
      const runId = ++this.exportRunId;
      this.exportDialog = true;
      this.exportLoading = true;
      this.exportStudents = [];
      this.exportSelectedPrograms = [];

      try {
        const students = await this.ensureAllStudents(this.programFilter);
        if (runId !== this.exportRunId) return; // dialog closed meanwhile
        this.exportStudents = students;
        this.preselectExportPrograms();
      } catch (e) {
        if (runId !== this.exportRunId) return;
        console.error("Export load failed", e);
        this.showMessage("error", "Failed to load students for export.");
        this.exportDialog = false;
      } finally {
        if (runId === this.exportRunId) this.exportLoading = false;
      }
    },

    async exportToExcel() {
      const students = this.exportFilteredStudents;
      if (!students.length) return;

      this.exporting = true;
      try {
        // Assessment columns, in order of first appearance
        const titles = [];
        students.forEach((s) => {
          const list = (s.skill_assessment && s.skill_assessment.data) || [];
          list.forEach((a) => {
            if (!titles.includes(a.title)) titles.push(a.title);
          });
        });
        const n = titles.length;
        if (n === 0) {
          this.showMessage("error", "No skill assessments found to export.");
          return;
        }

        const ExcelJS = (await import("exceljs")).default;
        const wb = new ExcelJS.Workbook();
        const ws = wb.addWorksheet("Skills Assessment");

        const totalCol = n + 3; // # | Name | 1..n | Total Score

        // Header rows
        ws.getCell(1, 1).value = "#";
        ws.mergeCells(1, 1, 2, 1);
        ws.getCell(1, 2).value = "Name";
        ws.mergeCells(1, 2, 2, 2);
        ws.getCell(1, 3).value = "Skills Assessment";
        if (n > 1) ws.mergeCells(1, 3, 1, n + 2);
        titles.forEach((_, i) => {
          ws.getCell(2, 3 + i).value = i + 1;
        });
        ws.getCell(1, totalCol).value = "Total Score";
        ws.mergeCells(1, totalCol, 2, totalCol);

        // Data rows
        students.forEach((s, idx) => {
          const list = (s.skill_assessment && s.skill_assessment.data) || [];
          const byTitle = {};
          list.forEach((a) => {
            byTitle[a.title] = a;
          });

          let total = 0;
          const row = [idx + 1, this.toTitleCase(s.name || "")];
          titles.forEach((t) => {
            const a = byTitle[t];
            if (a && a.isAnswered) {
              const score = Number(a.score) || 0;
              total += score;
              row.push(score);
            } else {
              row.push(null); // not taken -> blank
            }
          });
          row.push(total);
          ws.addRow(row);
        });

        // Layout & styling
        ws.getColumn(1).width = 6;
        ws.getColumn(2).width = 36;
        for (let c = 3; c <= n + 2; c++) ws.getColumn(c).width = 7;
        ws.getColumn(totalCol).width = 13;

        const thin = { style: "thin", color: { argb: "FF000000" } };
        const lastRow = ws.rowCount;
        for (let r = 1; r <= lastRow; r++) {
          for (let c = 1; c <= totalCol; c++) {
            const cell = ws.getCell(r, c);
            cell.border = { top: thin, left: thin, bottom: thin, right: thin };
            if (r <= 2) {
              cell.font = { bold: true };
              cell.alignment = { horizontal: "center", vertical: "middle" };
            }
          }
        }
        ws.views = [{ state: "frozen", xSplit: 2, ySplit: 2 }];

        // File name (program name added only when a single program is picked)
        const allSelected =
          this.exportSelectedPrograms.length ===
          this.exportProgramOptions.length;
        const programPart =
          !allSelected && this.exportSelectedPrograms.length === 1
            ? "_" + this.exportSelectedPrograms[0]
            : "";
        const fileName =
          `Skills-Assessment-Results_${this.batchItem.name}${programPart}`
            .replace(/[\\/:*?"<>|]/g, "")
            .replace(/\s+/g, "_") + ".xlsx";

        // Download
        const buffer = await wb.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);

        this.exportDialog = false;
        this.showMessage(
          "success",
          `Exported ${students.length} student(s) to Excel.`,
        );
      } catch (e) {
        console.error("Export failed", e);
        this.showMessage("error", "Failed to export the Excel file.");
      } finally {
        this.exporting = false;
      }
    },
  },
};
</script>

<style scoped>
.batch-card {
  border: 1px solid #d1d5db !important;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06) !important;
  transition: box-shadow 0.2s;
  cursor: pointer;
}
.batch-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.09) !important;
}
.batch-icon-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: #dcfce7;
}
.batch-title {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
  line-height: 1.3;
}
.batch-desc {
  font-size: 13px;
  color: #6b7280;
  line-height: 1.5;
}
.batch-meta {
  font-size: 12.5px;
  color: #6b7280;
}
.sa-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
  border-color: #10b981 !important;
}
</style>
